//-- React Standard
import { Button, Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';


//-- Custom
import { apiConstants } from '../../_constants/api.constants';
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import { settingsActions } from '../../_actions';
import { withStyles } from "@material-ui/core/styles";
import Footer from "../Common/Footer/Footer";

//-- CSS for Material
const styles = theme => ({
	error: {
		color: 'red',
	},
	loaderImg: {
		margin: '0 auto',
		display: 'block',
		width: '250px'
	},
	boldText: {
		fontWeight: 'bold'
	},
	pageImg: {
		width: '70px',
		height: '70px',
		position: 'relative',
		padding: '10px'
	},
	removeImg: {
		position: 'absolute',
		top: '-7px',
		right: '-7px',
		padding: '0px 7px 0px 7px',
		border: '1px solid #a09d9d',
		background: '#c1c1c1',
		borderRadius: '50%',
		fontWeight: 'bold',
		cursor: 'pointer',
		color: '#fff'
	},
	borderedImg: {
		position: 'relative',
		width: '70px',
		height: '70px',
		border: '1px #dad7d7 solid',
		borderRadius: '10px',
		float: 'left',
		marginBottom: '15px',
		marginRight: '15px'
	}
});

class GeneralSettings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			submitted: false,
			generalSettings: {
				admin_contact_person: '',
				admin_contact_email: '',
				support_email_1: '',
				accepted_emails: '',
				order_limit: '0'
			},
			profileUpdate: false,
			//-- We are using for validation
			errors: {}
		};
	}


	//-- Will need to fetch generalSettings data
	componentDidMount() {
		const { dispatch } = this.props;
		let obj = {};
		dispatch(settingsActions.getGeneralSettings(apiConstants.GET_GENERAL_SETTING, obj));
	}

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
	componentWillReceiveProps(props) {
		if (props.getGeneralSettings) {
	 
				if (props.getGeneralSettings.getSettings !== undefined &&
					props.getGeneralSettings.getSettings.data !== undefined && 
					props.getGeneralSettings.getSettings.data._id !== undefined &&
					props.getGeneralSettings.getSettings.data.contactPerson !== null  ) {

					let oldGenData = props.getGeneralSettings.getSettings.data;
					this.setState({
						generalSettings: {
							id : oldGenData._id,
							admin_contact_person : oldGenData.contactPerson,
							admin_contact_email : oldGenData.contactEmail,
							support_email_1 : oldGenData.supportEmail_1,	
							support_email_2 : oldGenData.supportEmail_2 !== null ? oldGenData.supportEmail_2 : undefined,
							office_address : oldGenData.officeAddress,
							office_city : oldGenData.officeCity,
							contact1 : oldGenData.officeContact_1,
							contact2: oldGenData.officeContact_2,
							accepted_emails: oldGenData.acceptedEmails,
							order_limit: oldGenData.orderLimit,
						}
					})
 
				}
		 
		}
	}


	//-- handle validation for page
	handleValidation() {
		const { siteConstants } = this.props.language;

		let fields = this.state.generalSettings;
		let errors = {};
		let formIsValid = true;
		const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		
		//Name
		if ((fields["admin_contact_person"] == '')) {
			formIsValid = false;
			if (fields["admin_contact_person"] == '') {
				errors["admin_contact_person"] = siteConstants.ERR_CAN_NOT_BLANK;
			}
		}

		if (fields["admin_contact_email"] == '') {
			formIsValid = false;
			if (fields["admin_contact_email"] == '') {
				errors["admin_contact_email"] = siteConstants.ERR_CAN_NOT_BLANK;
			}
		}
		else if( pattern.test(fields["admin_contact_email"]) == false ){
			formIsValid = false;
		 	errors["admin_contact_email"] = siteConstants.ERR_EMAIL_NOT_VALID;
			 
		}else{
			errors["admin_contact_email"] = '';
		}

		if ((fields["support_email_1"] == '')) {
			formIsValid = false;			
			errors["support_email_1"] = siteConstants.ERR_CAN_NOT_BLANK;
			
		}else if( pattern.test(fields["support_email_1"]) == false ){
			formIsValid = false;
		 	errors["support_email_1"] = siteConstants.ERR_EMAIL_NOT_VALID;
			 
		}else{ errors["support_email_1"] = '';}

		if( fields["support_email_2"] !== undefined &&
			fields["support_email_2"] !== '' &&
			pattern.test(fields["support_email_2"]) == false ){
			formIsValid = false;
		 	errors["support_email_2"] = siteConstants.ERR_EMAIL_NOT_VALID;
		}
		if (fields["accepted_emails"] == '') {
			formIsValid = false;
			if (fields["accepted_emails"] == '') {
				errors["accepted_emails"] = siteConstants.ERR_CAN_NOT_BLANK;
			}
		}
		if (fields["order_limit"] == '') {
			formIsValid = false;
			if (fields["order_limit"] == '') {
				errors["order_limit"] = siteConstants.ERR_CAN_NOT_BLANK;
			}
		}


		this.setState({ errors: errors });

		return formIsValid;
	}

	//-- update the general setting information
	updateGeneralSettings = (e) => {
		e.preventDefault();
		let obj = {}; 

		if (this.handleValidation()) {
			let { generalSettings } = this.state;
			this.props.dispatch(settingsActions.updateGeneralSettings(apiConstants.UPDATE_GENERAL_SETTINGS, generalSettings, apiConstants.GET_GENERAL_SETTING, obj ));
		}  
	}

	//-- we are setting the Values
	handleChange(event) {
		const { name, value } = event.target;
		const { generalSettings } = this.state;
		this.setState({
			generalSettings: {
				...generalSettings,
				[name]: value
			}
		});
	}

	//-- Main function
	render() {
		const { generalSettings } = this.state;
		const { siteConstants } = this.props.language;

		return (
			<div id="wrapper">

				<SideBar />

				<div id="content-wrapper" className="d-flex flex-column">
					{/* <!-- Main Content --> */}
					<div id="content">

						<TopBar />
						<nav className="" aria-label="breadcrumb">
							<ol className="breadcrumb">
								<li className="breadcrumb-item">
									<a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
								</li>
								<li className="breadcrumb-item">
									<a href="/settings">{siteConstants.LABEL_SETTINGS}</a>
								</li>
								<li className="active breadcrumb-item" aria-current="page">
									{siteConstants.LABEL_GENERAL_SETTINGS}
								</li>

								<li style={{ paddingLeft: "650px" }}>
                                    <a href="/settings" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
							</ol>
						</nav>

						{/* <!-- Begin Page Content --> */}
						<div className="container-fluid">
							<div className="row">
								<div className="col-md-12">
									<div className="row mb-2">
										<div className="col-md-12">
											<Card>
												<CardHeader>
													<strong>{siteConstants.LABEL_GENERAL_SETTINGS}</strong>
												</CardHeader>
												<CardBody>
													<form role="form">
														<div className="form-group">
															<label>{siteConstants.LABEL_ADMIN_CONTACT}</label>
															<label className="my-error">{this.state.errors["admin_contact_person"]}</label>
															<input type="text" className="form-control form-control-generalSettings" name="admin_contact_person"
																value={generalSettings.admin_contact_person} onChange={(e) => this.handleChange(e)} />
														</div>
														<div className="form-group">
															<label>{siteConstants.LABEL_ADMIN_EMAIL}</label>
															<label className="my-error">{this.state.errors["admin_contact_email"]}</label>
															<input type="email" className="form-control form-control-generalSettings" name="admin_contact_email"
																value={generalSettings.admin_contact_email} onChange={(e) => this.handleChange(e)} />
														</div>
														<div className="form-group row">
															<div className="col-sm-6 mb-3 mb-sm-0">
																<label>{siteConstants.LABEL_SUPPORT_EMAIL1}</label>
																<label className="my-error">{this.state.errors["support_email_1"]}</label> 
																<input type="email" className="form-control form-control-generalSettings" name="support_email_1"
																	value={generalSettings.support_email_1} onChange={(e) => this.handleChange(e)} />
															</div>
															<div className="col-sm-6 mb-3 mb-sm-0">
																<label>{siteConstants.LABEL_SUPPORT_EMAIL2}</label>
																<label className="my-error">{this.state.errors["support_email_2"]}</label>
																<input type="email" className="form-control form-control-generalSettings" name="support_email_2"
																	value={generalSettings.support_email_2} onChange={(e) => this.handleChange(e)} />
															</div>
														</div>
														<div className="form-group row">
															<div className="col-sm-6 mb-3 mb-sm-0">
																<label>{siteConstants.LABEL_OFFICE_ADDRESS}</label>
																<label className="my-error">{this.state.errors["office_address"]}</label>
																<input type="text" className="form-control form-control-generalSettings" name="office_address"
																	value={generalSettings.office_address} onChange={(e) => this.handleChange(e)} />
															</div>
															<div className="col-sm-6 mb-3 mb-sm-0">
																<label>{siteConstants.LABEL_OFFICE_CITY}</label>
																<label className="my-error">{this.state.errors["office_city"]}</label>
																<input type="text" className="form-control form-control-generalSettings" name="office_city"
																	value={generalSettings.office_city} onChange={(e) => this.handleChange(e)} />
															</div>
														</div>
														<div className="form-group row">
															<div className="col-sm-6 mb-3 mb-sm-0">
																<label>{siteConstants.LABEL_CONTACT1}</label>
																<label className="my-error">{this.state.errors["contact1"]}</label>
																<input type="number" className="form-control form-control-generalSettings" name="contact1"
																	value={generalSettings.contact1} onChange={(e) => this.handleChange(e)} />
															</div>
															<div className="col-sm-6 mb-3 mb-sm-0">
																<label>{siteConstants.LABEL_CONTACT2}</label>
																<label className="my-error">{this.state.errors["contact2"]}</label>
																<input type="number" className="form-control form-control-generalSettings" name="contact2"
																	value={generalSettings.contact2} onChange={(e) => this.handleChange(e)} />
															</div>
														</div>
														<div className="form-group row">
															<div className="col-sm-6 mb-3 mb-sm-0">
																<label>Accepted Emails for Registration</label>
																<label className="my-error">{this.state.errors["accepted_emails"]}</label>
																<input type="text" className="form-control form-control-generalSettings" name="accepted_emails"
																	value={generalSettings.accepted_emails} onChange={(e) => this.handleChange(e)} />
															</div>
															<div className="col-sm-6 mb-3 mb-sm-0">
																<label>Maximum Order Limit</label>
																<label className="my-error">{this.state.errors["order_limit"]}</label>
																<input type="text" className="form-control form-control-generalSettings" name="order_limit"
																	value={generalSettings.order_limit} onChange={(e) => this.handleChange(e)} />
															</div>
														</div>
													</form>
												</CardBody>
												<CardFooter>
													<Button variant="contained" color="primary" onClick={(e) => this.updateGeneralSettings(e)}>{siteConstants.LABEL_SAVE}</Button> &nbsp;
													<Button variant="contained" onClick={() => this.closeAddTaxPop()}>{siteConstants.LABEL_CANCEL}</Button>
												</CardFooter>
											</Card>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* <!-- /.container-fluid --> */}

					</div>
					{/* <!-- End of Main Content --> */}

					<Footer />
				</div>
			</div>
		);
	}
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
	const { language, getGeneralSettings } = state;
	return {
		language,
		getGeneralSettings
	};
}

const connectedGeneralSettings = connect(mapStateToProps)(withStyles(styles)(GeneralSettings));
export { connectedGeneralSettings as GeneralSettings };